var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVipLoungeServiceAirCond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.004 5L9.00399 8.00001C9.27999 8.27601 9.27999 8.72401 9.00399 9.00001C8.72799 9.27602 8.27999 9.27602 8.00399 9.00001L5.004 6C4.728 5.724 4.728 5.276 5.004 5C5.28 4.724 5.728 4.724 6.004 5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.256 10.754H13.752C13.34 10.754 13.004 10.42 13.004 10.006V9.99C13.004 9.578 13.338 9.242 13.752 9.242H17.256C17.668 9.242 18.004 9.576 18.004 9.99V10.006C18.004 10.42 17.668 10.754 17.256 10.754Z",
    fill: "#FFC629"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.052 11.238L14.814 9.99999L16.052 8.76199C16.344 8.47 16.344 7.994 16.052 7.702C15.76 7.41 15.284 7.41 14.992 7.702L13.224 9.46999C13.142 9.55199 13.082 9.64999 13.046 9.75199C12.954 10.016 13.014 10.32 13.224 10.53L14.992 12.298C15.284 12.59 15.76 12.59 16.052 12.298C16.344 12.006 16.344 11.53 16.052 11.238Z",
    fill: "#FFC629"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 9.24399H6.30199C6.71399 9.24399 7.04999 9.57799 7.04999 9.99199V10.008C7.04999 10.42 6.71599 10.756 6.30199 10.756H2.75C2.338 10.756 2.002 10.422 2.002 10.008V9.99199C2.004 9.57799 2.338 9.24399 2.75 9.24399Z",
    fill: "#FFC629"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.004 8.76199L5.242 9.99999L4.004 11.238C3.712 11.53 3.712 12.006 4.004 12.298C4.296 12.59 4.772 12.59 5.064 12.298L6.832 10.53C6.914 10.448 6.974 10.35 7.01 10.248C7.102 9.98399 7.042 9.67999 6.832 9.46999L5.064 7.702C4.772 7.41 4.296 7.41 4.004 7.702C3.71 7.994 3.71 8.47 4.004 8.76199Z",
    fill: "#FFC629"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.756 2.748V6.252C10.756 6.664 10.422 7 10.008 7H9.992C9.58 7 9.244 6.666 9.244 6.252V2.748C9.244 2.336 9.578 2 9.992 2H10.008C10.42 2 10.756 2.334 10.756 2.748Z",
    fill: "#FFC629"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.238 3.952L9.99999 5.19L8.76199 3.952C8.47 3.66 7.994 3.66 7.702 3.952C7.41 4.244 7.41 4.72 7.702 5.012L9.46999 6.78C9.55199 6.862 9.64999 6.922 9.75199 6.958C10.016 7.05 10.32 6.99 10.53 6.78L12.298 5.012C12.59 4.72 12.59 4.244 12.298 3.952C12.006 3.66 11.53 3.66 11.238 3.952Z",
    fill: "#FFC629"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.244 17.252V13.748C9.244 13.336 9.578 13 9.992 13H10.008C10.42 13 10.756 13.334 10.756 13.748V17.252C10.756 17.664 10.422 18 10.008 18H9.992C9.58 18 9.244 17.666 9.244 17.252Z",
    fill: "#FFC629"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76199 16.048L9.99999 14.81L11.238 16.048C11.53 16.34 12.006 16.34 12.298 16.048C12.59 15.756 12.59 15.28 12.298 14.988L10.53 13.22C10.448 13.138 10.35 13.078 10.248 13.042C9.98399 12.95 9.67999 13.01 9.46999 13.22L7.702 14.988C7.41 15.28 7.41 15.756 7.702 16.048C7.994 16.34 8.47 16.34 8.76199 16.048Z",
    fill: "#FFC629"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.75C10.4142 10.75 10.75 10.4142 10.75 10C10.75 9.58579 10.4142 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10C9.25 10.4142 9.58579 10.75 10 10.75Z",
    fill: "#FFC629"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.004 6L12.004 9.00001C11.728 9.27602 11.28 9.27602 11.004 9.00001C10.728 8.72401 10.728 8.27601 11.004 8.00001L14.004 5C14.28 4.724 14.728 4.724 15.004 5C15.28 5.276 15.28 5.724 15.004 6Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.004 15L11.004 12C10.728 11.724 10.728 11.276 11.004 11C11.28 10.724 11.728 10.724 12.004 11L15.004 14C15.28 14.276 15.28 14.724 15.004 15C14.728 15.276 14.28 15.276 14.004 15Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.004 14L8.00399 11C8.27999 10.724 8.72799 10.724 9.00399 11C9.27999 11.276 9.27999 11.724 9.00399 12L6.004 15C5.728 15.276 5.28 15.276 5.004 15C4.728 14.724 4.728 14.276 5.004 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipLoungeServiceAirCond);
export default __webpack_public_path__ + "static/media/vip-lounge-service-air_cond.e3ee52ad1471feb36c7b3c01116fcd2e.svg";
export { ForwardRef as ReactComponent };